import { render, staticRenderFns } from "./WorkshopSignup.vue?vue&type=template&id=0f7c5377&scoped=true&"
import script from "./WorkshopSignup.vue?vue&type=script&lang=ts&"
export * from "./WorkshopSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c5377",
  null
  
)

export default component.exports